

export const isEmpty = value => !value || !value.trim()

export const MAX_ALLOWED_LENGTH = 255
export const MAX_ALLOWED_WAYPOINTS = 10

export const AUTH_TOKEN = "auth_token";

export const isObject = val => {
    if(!val) {
        return false;
    }

    return typeof val === 'object' || typeof val === 'function';
}
